import React, { useState, useEffect, useCallback } from 'react'
import { useNavigate, useLocation } from 'react-router-dom'
import { useDispatch, useSelector } from 'react-redux'
import { useSnackbar } from 'notistack'
import utilServices from 'app/services/util-services'
import { updateIndicator } from 'app/redux/store/features/configs'
import { getUserById, selectItemById, updateUser } from 'app/redux/store/features/users'
import UpdateUserForm from './UpdateUserForm'

const UpdateUser = () => {
    const navigate = useNavigate()
    const dispatch = useDispatch()
    const { enqueueSnackbar } = useSnackbar()
    const { state } = useLocation()
    const { userId } = state
    const { users, loading, error } = useSelector((state) => state.users)
    const user = selectItemById(users, userId)
    const [apiCallInProgress, setApiCallInProgress] = useState(false)
    const [customerId, setCustomerId] = useState(user.customerId)

    useEffect(() => {
        if (utilServices.isNullOrUndefined(user.id)) dispatch(getUserById({ id: userId }))
    }, [])

    useEffect(() => {
        if (!apiCallInProgress || loading) return
        setApiCallInProgress(false)

        if (error) handleError(error)
        else {
            enqueueSnackbar('User updated successfully', {
                variant: 'success',
                anchorOrigin: {
                    vertical: 'top',
                    horizontal: 'right',
                },
            })
            dispatch(updateIndicator({ inProgress: false }))
            navigate('/security/users', { state: { navigateFrom: 'update-user' } })
        }
    }, [loading])

    function handleError(error) {
        if (error.status === '401') {
            navigate('/profile/signout')
        } else if (error.detail) {
            enqueueSnackbar(error.detail, {
                variant: 'error',
                anchorOrigin: {
                    vertical: 'top',
                    horizontal: 'right',
                },
            })
        } else {
            enqueueSnackbar(error, {
                variant: 'error',
                anchorOrigin: {
                    vertical: 'top',
                    horizontal: 'right',
                },
            })
        }
    }

    const onUpdateUser = useCallback(async () => {
        setApiCallInProgress(true)
        dispatch(updateIndicator({ inProgress: true }))
        dispatch(
            updateUser({
                ...user,
                birthDate: user.birthDate != null ? user.birthDate.toFilterStartDate() : null,
                customerId: customerId,
            })
        )
    }, [customerId])

    return (
        <React.Fragment>
            <UpdateUserForm
                userData={user}
                updateUser={onUpdateUser}
                customerId={customerId}
                setCustomerId={setCustomerId}
            />
        </React.Fragment>
    )
}

export default UpdateUser
